<template>
    <div class="body__content relative">
        <!-- <Header /> -->
        <div class="flex items-center justify-end pr-16 pt-16">
            <Locale class="mr-15px" />
            <User v-if="route.path.indexOf('login') < 0" />
        </div>
        <div class="text-#fff">
            <router-view />
        </div>
        <!-- <Footer /> -->
    </div>
</template>
<script setup lang="ts">
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import Locale from '@/layout/components/Locale.vue'
import User from '@/layout/components/User.vue'

const route = useRoute();
</script>
